import { render } from "./OrderDetail.vue?vue&type=template&id=3002a99b"
import script from "./OrderDetail.vue?vue&type=script&lang=js"
export * from "./OrderDetail.vue?vue&type=script&lang=js"
script.render = render

export default script